import { render, staticRenderFns } from "./projectEnd.vue?vue&type=template&id=6b22540c&scoped=true"
import script from "./projectEnd.vue?vue&type=script&lang=js"
export * from "./projectEnd.vue?vue&type=script&lang=js"
import style0 from "./projectEnd.vue?vue&type=style&index=0&id=6b22540c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22540c",
  null
  
)

export default component.exports